<template>
  <section class="prize--page" v-if="show">
    <van-overlay :show="show" z-index="2"/>
    <div class="prize__main">
      <div class="prize__noChange" v-if="noChange || overTime">
        <img src="@/assets/prize-nochange.png" alt="" v-if="noChange && !overTime" class="prize__noChange--img">
        <div class="prize__closePrize" @click="handleClose" v-if="noChange && !overTime"></div>
        <img src="@/assets/overtime.png" alt="" v-if='overTime' class="prize__noChange--img">
        <div class="prize__closePrize top" @click="handleClose" v-if="overTime"></div>
      </div>
      <div class="prize__reward" v-else-if='!noChange && !noReceive'>
        <img src="@/assets/prize-reward.png" alt="" class="prize__reward--main">
        <img src="@/assets/prize-btn.gif" @click="handleLottery" alt="" class="prize__reward--btn">
        <img src="@/assets/tips-close.png" @click="handleClose" alt="" class="prize__reward--close">
      </div>
      <div class="prize__receive" v-else-if="!noChange && noReceive">
        <img src="@/assets/prize-receive.png" alt="" class="prize__receive--main">
        <p class="prize__receive--text">{{this.money}}元</p>
        <img src='@/assets/prize-receiveBtn.png' class="prize__receive--btn" @click="handleReveice">
        <img src="@/assets/tips-close.png" @click="handleClose" alt="" class="prize__receive--close">
      </div>
    </div>
  </section>
</template>

<script>
import { Toast } from 'vant'
export default {
  props: {
    show: {
      type: Boolean
    },
    noChange: {
      type: Boolean
    },
    overTime: {
      type: Boolean
    }
  },
  data () {
    return {
      noReceive: false,
      ticket: '',
      text: '',
      money: ''
    }
  },
  methods: {
    handleClose () {
      this.$emit('prizeClose')
    },
    async handleLottery () {
      const lotteryCount = localStorage.getItem('lotteryCount')
      localStorage.setItem('lotteryCount', lotteryCount - 1)
      // this.$store.commit('setUserLottery', this.$store.state.user_day_lottery_count - 1)
      this.$stat({
        event: 'openPrizeBtn' // 上报埋点信息--拆红包
      })
      try {
        const { data } = await this.$fetch.post('/lottery/lottery', { able_type: localStorage.getItem('setPackageName') })
        if (data.status === 0) {
          this.$emit('noPrize')
        } else {
          this.noReceive = true
          this.ticket = data.ticket
          this.money = data.money
        }
      } catch (error) {
        Toast(error.response.data.message)
      }
    },
    async handleReveice () {
      this.$stat({
        event: 'receivePrize' // 上报埋点信息--开心收下
      })
      window.location.href = 'https://passport.inrice.cn/web/reduction-gold/dist/#/home?ticket=' + encodeURIComponent(this.ticket)
    }
  }
}
</script>

<style lang="scss">
.prize--page{
  @mixin absolute () {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
  .prize__{
    &noChange{
      z-index: 3;
      @include absolute();
      top: 210px;
      width: 630px;
      .top{
        top: 400px !important;
      }
    }
    &closePrize{
      z-index: 3;
      @include absolute();
      top: 495px;
      width: 340px;
      height: 90px;
    }
    &reward{
      position: relative;
      z-index: 3;
      &--main{
        @include absolute();
        top: 160px;
        width: 600px;
      }
      &--btn{
        @include absolute();
        top: 524px;
        width: 163px;
      }
      &--close{
        @include absolute();
        top: 894px;
        width: 47px;
      }
    }
    &receive{
      position: relative;
      z-index: 3;
      &--main{
        @include absolute();
        top: 160px;
        width: 600px;
      }
      &--btn{
        @include absolute();
        top: 534px;
        width: 319px;
      }
      &--text{
        @include absolute();
        text-align: center;
        top: 280px;
        font-size:84px;
        font-family:Source Han Sans CN;
        font-weight:bold;
        color:#AA2D2D;
      }
      &--close{
        @include absolute();
        top: 794px;
        width: 47px;
      }
    }
  }
}
</style>